import { createAction, props } from '@ngrx/store';
import { IOptions } from '@shared';

export const loadAdminType = createAction('[Admin Type] Load Admin Type');
export const loadAdminTypeSuccess = createAction(
  '[Admin Type] Load Admin Type Success',
  props<{ adminType: IOptions[] }>(),
);
export const addAdminType = createAction(
  '[Admin Type] Add Admin type',
  props<{
    adminType: IOptions;
  }>(),
);
export const removeAdminType = createAction('[Admin Type] Remove Admin type', props<{ adminTypeId: string }>());
export const updateAdminType = createAction('[Admin Type] Update Admin type', props<{ adminType: IOptions }>());
